<template>
  <div class="order">
    <div class="filter-container">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="75px">
        <el-form-item label="配件代码">
          <el-input v-model="searchForm.partCode" placeholder="请输入配件代码"></el-input>
        </el-form-item>
        <el-form-item label="配件名称">
          <el-input v-model="searchForm.partName" placeholder="请输入配件名称"></el-input>
        </el-form-item>
        <el-form-item label="更新时间">
          <el-date-picker
            v-model="searchForm.updateDateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button type="primary" plain @click="handleResetQuery">重置</el-button>
      </el-form>
    </div>
    <div class="table-container">
      <div class="table-btn">
        <el-button type="text" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <el-button type="text" icon="el-icon-upload2" @click="handleImport">批量导入</el-button>
        <el-button type="text" icon="el-icon-download" @click="handleExport">导出</el-button>
      </div>
      <el-table
        :data="tableData"
        highlight-current-row
        border
        stripe
      >
        <el-table-column
          type="selection"
          width="40"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="50"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="partCode"
          label="配件代码"
          align="center"
          min-width="190"
        >
        </el-table-column>
        <el-table-column
          prop="partName"
          label="配件名称"
          min-width="170"
        >
        </el-table-column>
        <el-table-column
          prop="partPrice"
          label="配件单价"
          align="center"
          min-width="110"
        >
        </el-table-column>
        <el-table-column
          prop="managementFeeRate"
          label="管理费费率"
          align="center"
          min-width="110"
        >
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="配件总金额"
          align="center"
          min-width="110"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="更新时间"
          width="170"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.updateTime ? scope.row.updateTime.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="updateByName"
          label="更新人"
          align="center"
          min-width="110"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="handleEdit(scope.row)"
            >编辑</el-button>
            <el-button
              type="text"
              @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="配件代码" prop="partCode">
          <el-input v-model="form.partCode" placeholder="请输入配件代码"></el-input>
        </el-form-item>
        <el-form-item label="配件名称" prop="partName">
          <el-input v-model="form.partName" placeholder="请输入配件名称"></el-input>
        </el-form-item>
        <el-form-item label="配件单价" prop="partPrice">
          <el-input-number
            v-model="form.partPrice"
            :controls="false"
            :precision="2"
            :min="0.01"
            placeholder="请输入配件单价"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="管理费费率" prop="managementFeeRate">
          <el-input-number
            v-model="form.managementFeeRate"
            :controls="false"
            :precision="2"
            placeholder="请输入管理费费率"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer-button">
        <el-button type="primary" :loading="saveLoading" @click="handleSave">确定</el-button>
        <el-button @click="dialogVisible = false" plain>取消</el-button>
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="deleteDialogVisible"
      width="500px"
      append-to-body
      :close-on-click-modal="false"
    >
      <div style="text-align: center; padding: 20px 0;display: flex; align-items: center;">
        <i class="el-icon-warning" style="color: #E6A23C; font-size: 20px; margin-right: 10px;"></i>
        <p style="font-size: 16px;">确定要删除该预授权设置吗？</p>
      </div>
      <div slot="footer" class="dialog-footer-button">
        <el-button type="primary" :loading="deleteLoading" @click="confirmDelete">确定</el-button>
        <el-button plain @click="deleteDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量导入" :visible.sync="importDialogVisible" width="500px" append-to-body>
      <div style="padding: 10px 0;">
        <div style="text-align: right; margin-bottom: 10px;">
          <el-button type="text" icon="el-icon-download" @click="handleDownloadTemplate">下载模板</el-button>
        </div>
        <el-upload
          ref="uploadExcel"
          :action="importAction"
          :headers="header"
          :auto-upload="false"
          :show-file-list="true"
          :limit="1"
          :on-change="handleImportFileChange"
          :on-remove="handleImportFileRemove"
          :on-success="handleImportSuccess"
          :on-error="handleImportError"
          accept=".xlsx,.xls"
        >
          <el-button size="small" type="primary">选择文件</el-button>
          <div slot="tip" style="color: #909399; margin-top: 10px;">
            请上传Excel文件（.xlsx/.xls）
          </div>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer-button">
        <el-button type="primary" :loading="importLoading" :disabled="!selectedImportFile" @click="handleConfirmImport">确定导入</el-button>
        <el-button plain @click="importDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  activityPreAuthorizationList,
  activityPreAuthorizationAdd,
  activityPreAuthorizationEdit,
  activityPreAuthorizationDelete,
  activityPreAuthorizationExport,
  activityPreAuthorizationImport, getPreAuthorizationTemplate
} from "@/api/seek";
import { getDownloadFiles } from "@/util/downFile";
import {uploadUrl} from "@/util/url";

export default {
  data() {
    return {
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      searchForm: {
        partCode: '',
        partName: '',
        updateDateRange: []
      },
      searchInfo: {},
      dialogVisible: false,
      dialogTitle: '新增预授权设置',
      form: {
        id: '',
        partCode: '',
        partName: '',
        partPrice: undefined,
        managementFeeRate: undefined
      },
      rules: {
        partCode: [{ required: true, message: "配件代码不能为空", trigger: ["blur", "change"] }],
        partName: [{ required: true, message: "配件名称不能为空", trigger: ["blur", "change"] }],
        partPrice: [{ required: true, message: "配件单价不能为空", trigger: ["blur", "change"] }],
        managementFeeRate: [{ required: true, message: "管理费费率不能为空", trigger: ["blur", "change"] }]
      },
      saveLoading: false,
      deleteDialogVisible: false,
      deleteLoading: false,
      currentDeleteRow: null,
      importDialogVisible: false,
      importLoading: false,
      importAction: '',
      header: {
        satoken: sessionStorage.getItem("token")
      },
      selectedImportFile: null
    };
  },
  mounted() {
    this.getList();
    this.importAction = uploadUrl + "/manage/preAuthorization/import";
  },
  methods: {
    handleSearch() {
      let params = { ...this.searchForm };
      if (params.updateDateRange && params.updateDateRange.length === 2) {
        params.updateTimeStart = params.updateDateRange[0];
        params.updateTimeEnd = params.updateDateRange[1];
      }
      delete params.updateDateRange;
      this.searchInfo = params;
      this.page = 1;
      this.pageSize = 10;
      this.getList();
    },
    handleResetQuery() {
      this.searchForm = {
        partCode: '',
        partName: '',
        updateDateRange: []
      };
      this.handleSearch();
    },
    async getList() {
      let query = {
        data: {
          ...this.searchInfo
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await activityPreAuthorizationList(query);
      if (res.status == 0) {
        this.tableData = res.data.records || [];
        this.total = res.data.count || 0;
      }
    },
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: '',
        partCode: '',
        partName: '',
        partPrice: undefined,
        managementFeeRate: undefined
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    handleAdd() {
      this.dialogTitle = '新增预授权设置';
      this.dialogVisible = true;
      this.resetForm();
    },
    handleEdit(row) {
      this.dialogTitle = '编辑预授权设置';
      this.dialogVisible = true;
      this.resetForm();
      this.form = {
        authorizationId: row.authorizationId,
        partCode: row.partCode,
        partName: row.partName,
        partPrice: row.partPrice,
        managementFeeRate: row.managementFeeRate
      };
    },
    handleSave() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.saveLoading = true;
        try {
          let res;
          if (this.form.authorizationId) {
            res = await activityPreAuthorizationEdit({ data: this.form });
          } else {
            res = await activityPreAuthorizationAdd({ data: this.form });
          }
          if (res.status == 0) {
            this.dialogVisible = false;
            this.$DonMessage.success('操作成功');
            this.getList();
          } else {
            this.$DonMessage.error(res.message || '操作失败');
          }
        } catch (error) {
          console.error(error);
        }
        this.saveLoading = false;
      });
    },
    handleDelete(row) {
      this.currentDeleteRow = row;
      this.deleteDialogVisible = true;
    },
    async confirmDelete() {
      this.deleteLoading = true;
      try {
        const res = await activityPreAuthorizationDelete({
          data: { authorizationId: this.currentDeleteRow.authorizationId }
        });
        if (res.status == 0) {
          this.deleteDialogVisible = false;
          this.$DonMessage.success('删除成功');
          this.getList();
        } else {
          this.$DonMessage.error(res.message || '操作失败');
        }
      } catch (error) {
        console.error(error);
      }
      this.deleteLoading = false;
    },
    handleImport() {
      if (this.$refs.uploadExcel) {
        this.$refs.uploadExcel.clearFiles();
      }
      this.selectedImportFile = null;
      this.importDialogVisible = true;
    },
    handleImportFileChange(file, fileList) {
      if (fileList.length > 0) {
        this.selectedImportFile = fileList[0];
      } else {
        this.selectedImportFile = null;
      }
    },
    handleImportFileRemove(file, fileList) {
      this.importLoading = false;
      if (fileList.length === 0) {
        this.selectedImportFile = null;
      }
    },
    handleConfirmImport() {
      if (!this.selectedImportFile) {
        this.$DonMessage.warning('请选择要导入的文件');
        return;
      }
      this.importLoading = true;
      this.$refs.uploadExcel.submit();
      this.importLoading = false;
    },
    handleImportSuccess(res) {
      this.importLoading = false;
      if (res.status == 0) {
        this.importDialogVisible = false;
        this.$DonMessage.success('导入成功');
        this.getList();
      } else {
        this.importLoading = false;
        this.$DonMessage.error(res.message || '导入失败');
      }
    },
    handleImportError(err) {
      this.importLoading = false;
      this.$DonMessage.error('导入失败');
    },
    async handleDownloadTemplate() {
      const res = await getPreAuthorizationTemplate({data:{}});
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success('下载成功');
      }
      // window.open(this.$baseUrl + '/manage/preAuthorization/template', '_blank');
    },
    async handleExport() {
      const res = await activityPreAuthorizationExport({
        data: { ...this.searchInfo }
      });
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success('导出成功');
      }
    }
  }
};
</script>

<style src="@/assets/css/qualityStyle.css"></style>
